import m from "../../es2015/themes/animated";
window.am4themes_animated = m;


//////////////////
// WEBPACK FOOTER
// ./themes/animated.js
// module id = null
// module chunks = 